const sizes = {
  small: "small",
  medium: "medium",
  large: "large",
};

export default sizes;
